// CUSTOM CODE for RUGETTE
// Collection of small fixes/patches for Judge.me's review widget, which
// renders client-side after this script loads. Keep unrelated Judge.me
// patches in this one file instead of spawning a new <script> per fix.

(function () {
  // Judge.me's app blocks render their .jdgm-widget containers server-side
  // and fill them in client-side. Pages without one (home, collections)
  // have nothing to fix, so skip everything there, and on pages with one
  // only watch and query inside those containers instead of the whole
  // document.
  var widgets = document.querySelectorAll('.jdgm-widget');
  if (!widgets.length) return;

  function queryWidgets(selector) {
    var found = [];
    widgets.forEach(function (widget) {
      widget.querySelectorAll(selector).forEach(function (el) {
        found.push(el);
      });
    });
    return found;
  }

  // --- Fix 1: badge click doesn't scroll to the review widget -----------
  // Judge.me's preview badge (stars + review count) doesn't scroll to the
  // review widget on click on this theme. We do it ourselves via event
  // delegation, since the badge is rendered by Judge.me's app block after
  // this script loads.
  //
  // Registered on the capture phase: Judge.me's own click handler on the
  // badge calls stopPropagation() during the bubble phase, so a normal
  // (bubble-phase) document listener never sees the click.
  document.addEventListener(
    'click',
    function (event) {
      var badge = event.target.closest('.jdgm-prev-badge');
      if (!badge) return;

      var widget = document.querySelector('.jdgm-review-widget');
      if (!widget) return;

      widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    true
  );

  // --- Fix 2: duplicate SVG ids (accessibility) --------------------------
  // Judge.me's review widget renders the same inline SVG icon (verified
  // buyer badge, star icons, etc.) once per review. Each copy ships with
  // the same hard-coded id on its <mask>/<clipPath> elements, so a page
  // with several reviews ends up with duplicate id="..." values in the DOM
  // — an accessibility violation (WCAG 4.1.1) flagged by axe/Lighthouse.
  //
  // Reviews can be paginated/lazy-loaded, so we watch the DOM and rewrite
  // any duplicate id we find on the second+ occurrence, patching the
  // attributes that reference it (mask, fill, clip-path, filter, href)
  // inside the same <svg> so the icon keeps rendering correctly.
  var REF_ATTRS = ['mask', 'fill', 'stroke', 'clip-path', 'filter'];

  function dedupeSvgIds() {
    var seen = Object.create(null);
    var svgs = queryWidgets('.jm-review-widget svg, .jdgm-review-widget svg');

    svgs.forEach(function (svg, svgIndex) {
      var idEls = svg.querySelectorAll('[id]');

      idEls.forEach(function (el) {
        var oldId = el.id;
        if (!oldId || !seen[oldId]) {
          seen[oldId] = true;
          return;
        }

        var newId = oldId + '-dup' + svgIndex;
        el.id = newId;

        REF_ATTRS.forEach(function (attr) {
          svg
            .querySelectorAll('[' + attr + '="url(#' + oldId + ')"]')
            .forEach(function (ref) {
              ref.setAttribute(attr, 'url(#' + newId + ')');
            });
        });

        svg
          .querySelectorAll('use[href="#' + oldId + '"]')
          .forEach(function (use) {
            use.setAttribute('href', '#' + newId);
          });
      });
    });
  }

  // --- Fix 3: accessible name doesn't include visible text (WCAG 2.5.3) --
  // Judge.me's average-rating link (".jm-average-rating-display") ships an
  // aria-label like "View reviews on the ..." that doesn't contain the
  // widget's own visible text (star rating / review count). A voice
  // control user saying the visible text can't activate the link. We
  // prepend the visible text to the label so the accessible name always
  // contains what's on screen, keeping the extra context Judge.me added.
  function fixRatingDisplayLabel() {
    queryWidgets('.jm-average-rating-display[aria-label]').forEach(function (el) {
      var visibleText = el.textContent.trim().replace(/\s+/g, ' ');
      if (!visibleText) return;

      var label = el.getAttribute('aria-label');
      if (label.toLowerCase().indexOf(visibleText.toLowerCase()) !== -1) return;

      el.setAttribute('aria-label', visibleText + ' - ' + label);
    });
  }

  var scheduled = false;
  function runFixes() {
    scheduled = false;
    dedupeSvgIds();
    fixRatingDisplayLabel();
  }
  function scheduleFixes() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(runFixes);
  }

  document.addEventListener('DOMContentLoaded', scheduleFixes);

  var observer = new MutationObserver(scheduleFixes);
  widgets.forEach(function (widget) {
    observer.observe(widget, { childList: true, subtree: true });
  });
})();
